import PropTypes from 'prop-types';
import React, { Component } from 'react';
import isDomUsable from '@fenderdigital/utils/dom';

/**
 * Wrapper that will fire props.onResize on resize events.
 * Will remove listeners upon unmounting.
 */

class ResizeHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: isDomUsable() ? window.innerWidth : 0,
    };
    this.onResize = this.onResize.bind(this);
  }

  componentDidMount() {
    if (isDomUsable()) window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    if (isDomUsable()) window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    const { onResize } = this.props;
    this.setState({ width: window.innerWidth }, () => {
      const { width } = this.state;
      onResize(width);
    });
  }

  render() {
    const { children } = this.props;
    return <div className="resize-handler">{children} </div>;
  }
}

ResizeHandler.propTypes = {
  onResize: PropTypes.func,
  children: PropTypes.shape({}),
};

ResizeHandler.defaultProps = {
  onResize: () => {},
  children: null,
};

export default ResizeHandler;
